import { List, Text } from '@mantine/core'

import { Section } from '../../components/SectionHeader'
import { LegalPage } from './LegalPage'

/** `/delete-account`: no sign-in needed, so it still works for someone who can't sign in. */
export function DeleteAccountPage() {
  return (
    <LegalPage title="Delete your account">
      <Text size="sm">
        You can delete your Macrotide account and everything it holds at any time. Deleting starts a{' '}
        <b>30-day grace period</b> rather than deleting straight away — see &quot;Timing&quot; below.
      </Text>

      <Section title="How to delete" card={false}>
        <List size="sm">
          <List.Item>
            <b>In the app:</b> Settings › Account and sync › Delete account.
          </List.Item>
          <List.Item>
            <b>On the web, signed in:</b> Settings › Data &amp; integrations has a &quot;Delete account&quot;
            button, with a double confirmation. It tells you the date your account will be deleted, then signs you
            out.
          </List.Item>
          <List.Item>
            <b>Signed out:</b> sign in first and use one of the options above, or email
            macrotide@ikarosdev.com from your account&apos;s email address and we&apos;ll delete it for you.
          </List.Item>
        </List>
      </Section>

      <Section title="What gets deleted" card={false}>
        <Text size="sm">
          Your account and all the data it holds on our servers: your food log, recipes and custom foods, weight
          and body metrics, profile, goals, workouts, programs, equipment, photos and AI reports.
        </Text>
      </Section>

      <Section title="Timing" card={false}>
        <Text size="sm">
          Deleting your account doesn&apos;t erase it immediately: it starts a 30-day grace period. If you sign in
          again before that period ends, the deletion is cancelled and your account carries on exactly as it was.
          If you don&apos;t, a nightly job permanently deletes your account and everything it holds once the 30
          days are up. Our backups roll off a further 30 days after that, so a trace can remain in a backup for up
          to 60 days in total before it&apos;s gone for good.
        </Text>
      </Section>
    </LegalPage>
  )
}
